import { render, staticRenderFns } from "./send-bill-list.vue?vue&type=template&id=500bf952&scoped=true"
import script from "./send-bill-list.vue?vue&type=script&lang=js"
export * from "./send-bill-list.vue?vue&type=script&lang=js"
import style0 from "./send-bill-list.vue?vue&type=style&index=0&id=500bf952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bf952",
  null
  
)

export default component.exports